import { defineAction, object, string } from '~/prix'
import { appSebraeAttendanceExpression } from '~/packages/appSebrae/stats/appSebraeAttendanceStats.definition'
import generateAgentReportHeatmapDataAction from './generateAgentReportHeatmapData.action.json' assert { type: 'json' }

const seedAgentReportHeatmapDefinition = defineAction({
  ...(generateAgentReportHeatmapDataAction),
  input: object({
    agentCpf: string(),
    startDate: string(),
    endDate: string(),
    filter: appSebraeAttendanceExpression.isOptional(),
  }),
  output: object({}),
})

export default seedAgentReportHeatmapDefinition
